import { Clock, CheckSquare } from "lucide-react";
import { StatusBadge } from "../../shared/StatusBadge";

interface MeetingStatsProps {
  duration: string;
  actionItemsCount: number;
  onActionItemsClick: () => void;
  status: string;
}

export function MeetingStats({
  duration,
  actionItemsCount,
  onActionItemsClick,
  status
}: MeetingStatsProps) {
  return (
    <div className="flex flex-col md:flex-row gap-3 md:gap-6">
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4" />
        <span>{duration}</span>
      </div>
      <div className="flex items-center gap-2">
        <CheckSquare className="h-4 w-4" />
        <button
          onClick={onActionItemsClick}
          className="hover:underline cursor-pointer"
        >
          {actionItemsCount} Action Item{actionItemsCount !== 1 ? 's' : ''}
        </button>
      </div>
      <div className="flex items-center gap-2">
        <StatusBadge status={status as any} />
      </div>
    </div>
  );
}